module.exports = __webpack_public_path__ + "images/unfold_icon.e7f118d4ec26ffb26f366539e776a2f7.png";